/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { CustomerLockControllerService } from './services/customer-lock-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    CustomerLockControllerService,
    ApiConfiguration
  ],
})
export class BillableServiceAsdlockModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<BillableServiceAsdlockModule> {
    return {
      ngModule: BillableServiceAsdlockModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: BillableServiceAsdlockModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('BillableServiceAsdlockModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
